import { render, staticRenderFns } from "./AgentNoteForm.vue?vue&type=template&id=684ace60&"
import script from "./AgentNoteForm.vue?vue&type=script&lang=js&"
export * from "./AgentNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./AgentNoteForm.vue?vue&type=style&index=0&id=684ace60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports